import { render } from "./404Page.vue?vue&type=template&id=540241ec"
import script from "./404Page.vue?vue&type=script&lang=ts"
export * from "./404Page.vue?vue&type=script&lang=ts"
script.render = render

export default script